import * as React from 'react';
import * as styles from './styles.module.scss';
import cls from "classnames";

export const RoadmapTable = () => {


    return <>
        <p className={styles.paragraph}>Alpaquita and Alpaquita container LTS versions get support for at least four years after
            the release. A new LTS version comes out approximately every two years, creating a
            two-year overlap, during which two versions will be supported simultaneously</p>
        <div className={cls(styles.wrapper, "el-scrollable")}>
            <table className={cls(styles.table)}>
                <thead>
                <tr>
                    <th>RELEASE</th>
                    <th>RELEASE YEAR</th>
                    <th>END OF COMMERCIAL SUPPORT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Alpaquita LTS 23</td>
                    <td>2023</td>
                    <td>2026</td>
                </tr>
                <tr>
                    <td>Alpaquita LTS 25</td>
                    <td>2025</td>
                    <td>2031</td>
                </tr>
                </tbody>
            </table>
        </div>
    </>
};
